import yaml from "js-yaml";
import { UserStoryGroupCollection, UserStoryYaml } from "./UserStory2";

export function dummyYaml() {
  return `
settings:
  note:
    styles:
      width: 100px
      height: 75px
      bgcolor: lightyellow
  groups:
    backbones:
      - name: epics
        label: EPICS
        bgcolor: pink
      - name: acts
        label: ACTIVITIES
        bgcolor: skyblue
    slices:
      - name: release1
        label: RELEASE 1
        visible: true
      - name: release2
        label: RELEASE 2
        visible: true
      - name: release3
        label: RELEASE 3
        visible: true
data:
  epics:
    - :: Organize Email
      acts:
        - :: Search Email
          release1:
            - :: Search by Keyword
              tags: [WIP]
          release2:
            - :: Limit Search to one field
            - :: Limit Search to 1+ fields
          release3:
            - :: Search attachments
            - :: Search sub folders
        - :: File Emails
          release1:
            - :: Move Emails
            - :: Create sub folders
              tags: [Done]
    - :: Manage Email
      acts:
        - :: Compose Email
          release1:
            - :: Create and send basic email
              tags: [Done]
            - :: Send RTF e-mail
          release2:
            - :: Send HTML e-mail
            - :: Set email priority
          release3:
            - :: Get address from contacts
            - :: Send Attachments
        - :: Read Email
          release1:
            - :: Open basic email
              tags: [Done]
            - :: Open RTF e-mail
          release2:
            - :: Open HTML e-mail
            - :: Open Attachments
        - :: Delete Email
          release1:
            - :: Delete email
          release2:
            - :: Empty Deleted Items
    - :: Manage Calendar
      acts:
        - :: View Calendar
          release1:
            - :: View list of appts
            - :: View Monthly formats
          release2:
            - :: View Daily Format
          release3:
            - :: View Weekly Formats
            - :: Search Calendar
        - :: Create Appt
          release1:
            - :: Create basic appt
            - :: Create RTF appt
          release2:
            - :: Create HTML appt
            - :: Mandatory / Optional
          release3:
            - :: Get address from contacts
            - :: Add Attachments
        - :: Update Appt
          release1:
            - :: Update contents / location
          release2:
            - :: Propose new time
        - :: View Appt
          release1:
            - :: View Appt
            - :: Accept / Reject / Tentative
          release3:
            - :: View Attachments
    - :: Manage Contacts
      acts:
        - :: Create Contact
          release1:
            - :: Create basic contact
          release2:
            - :: Add address data
          release3:
            - :: Import Contacts
            - :: Export Contacts
        - :: Update Contact
          release1:
            - :: Update contact info
          release2:
            - :: Update Address Info
        - :: Delete Contact
          release2:
            - :: Delete Contact
`;
}

export function dummySettings() {
  return UserStoryYaml.fromYaml(dummyYaml()).settings;
}

export function dummyData() {
  const {data, settings} = UserStoryYaml.fromYaml(dummyYaml());
  return (new UserStoryGroupCollection(data, settings)).data;
}
